import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { first, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Check } from '../../classes';

import * as _firebase from 'firebase/app';
import 'firebase/functions';
const firebase = _firebase;

export type DrawnData = {[q_id:string]:{[o_id:string]:{[order_key:string]:Check[]}}};
@Injectable({
  providedIn: 'root'
})
export class DrawService {
  constructor(private db: AngularFireDatabase, private auth: AuthService) {
  }

  data:DrawnData;
  fetch(survey_id: string): Observable<DrawnData> {
    return this.db
      .object<Partial<DrawnData>>(`draw/${survey_id}/drawn`)
      .valueChanges()
      .pipe(
        first(),
        tap(data=>this.data = data),
      );
  }
}
